'use strict';

import React from 'react';
import PropTypes from 'prop-types';

const COUNTRY = 'country';
const CONTINENT = 'continent';

export default class SelectRange extends React.Component {
  static propTypes = {
    defaultValue: PropTypes.string.isRequired,
    data: PropTypes.array.isRequired,
    updater: PropTypes.object.isRequired,
    model: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = { value: props.defaultValue };
  }

  handleChange(e) {
    var value = e.target.value;
    this.setState({value: value});
    this.props.updater.emit('country.show', value === COUNTRY);
    this.props.updater.emit('continent.show', value === CONTINENT);
  }

  render() {
    var data = this.props.data;
    var options = [];
    for (var i = 0; i < data.length; i++) {
      options.push(
        <option value={data[i].value} key={i}>{data[i].text}</option>
      );
    }
    return (
      <div>
        <label htmlFor={this.props.model + '_range'} className="label">
          Range<abbr title="required">*</abbr>
        </label>
        <select
          ref="select"
          name={this.props.model + '[range]'}
          id={this.props.model + '_range'}
          value={this.state.value}
          onChange={this.handleChange.bind(this)}>
          {options}
        </select>
      </div>
    );
  }
}
